import styled from 'styled-components';
import MyTypography from '../../components/Typography';
import PlanCard from '../../components/ProductCard/PlanCard';
import DeviceCard from '../../components/ProductCard/DeviceCard';
import { useNavigate } from 'react-router-dom';
import Space from '../../components/Space';
import { breakpoint } from '../../utils/responsive';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { gaSelectItem } from '../../utils/ga';
import { gtmSelectItem } from '../../utils/gtm';

const SuggestItem = ({ data }) => {
  const { t } = useTranslation('shoppingCart');
  let navigate = useNavigate();

  const onClickSelectItem = (item, type) => {
    // GA event
    const gaPayload = { ...item, isAddedFromRecommend: true };
    gaSelectItem(gaPayload);
    gtmSelectItem(gaPayload);

    navigate(`/${type}/${item?._id}`, { state: { isRecommend: true }});
  }

  return (
    <Container>
      <MyTypography
        fontSize="32"
        bold
        textAlign="center"
        style={{ marginBottom: 30, padding: '0 30px' }}
      >
        {t('needAnythingElse')}
      </MyTypography>
      <Grid container justifyContent="center" spacing={7}>
        {data &&
          data.map((item) => {
            if (item?.type === 'plan') {
              return (
                <PlanCardContainer item>
                  <PlanCard
                    type="animation"
                    data={item}
                    handleClick={() => onClickSelectItem(item, "mobile")}
                    isRecommend={true}
                  />
                </PlanCardContainer>
              );
            } else {
              return (
                <PlanCardContainer item sx={{ marginTop: 'auto' }}>
                  <DeviceCard
                    data={item}
                    handleClick={() => onClickSelectItem(item, "device")}
                    style={{ height: 550 }}
                  />
                </PlanCardContainer>
              );
            }
          })}
      </Grid>
    </Container>
  );
};

const Container = styled.div`
  background-color: #f7f7f7;
  padding: 50px 0px 100px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const PlanCardContainer = styled(Grid)`
  @media ${breakpoint.mobile} {
    && {
      margin-bottom: 30px;
    }
  }
`;

export default SuggestItem;
